import { t } from '@/utils/i18n'
import React, { useEffect, useRef, useState } from 'react'
import styles from './RemarkBox.module.less'

interface RemarkBoxProps {
  status: boolean
  value: string
  confirm: (value: string) => void
  cancel: () => void
}

const RemarkBox: React.FC<RemarkBoxProps> = (props) => {
  const { status, value, confirm, cancel } = props
  const textarea = useRef<HTMLTextAreaElement>(null)
  const [valueLen, setValueLen] = useState(0)

  useEffect(() => {
    if (textarea.current) {
        textarea.current.focus()
        textarea.current.setSelectionRange(value.length, value.length)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status])

  useEffect(() => {
    setValueLen(value.length)
  }, [value])

  function handleInput(e: React.ChangeEvent<HTMLTextAreaElement>) {
    setValueLen(e.target.value.length)
  }

  function handleCancelRemark() {
    cancel()
  }

  function handleSubmitRemark() {
    confirm(textarea.current?.value || '')
  }

  return (
    <div className={styles['remark-modal-wrapper']}>
      <div className={styles['remark-modal-mask']}></div>
      <div className={styles['remark-modal']}>
        <div className={styles['remark-textarea']}>
          <textarea
            rows={4}
            ref={textarea}
            className={styles['textarea']}
            placeholder={t('输入内容')}
            maxLength={1000}
            name="text"
            onInput={handleInput}
            defaultValue={value}
          ></textarea>
          <div className={styles['number-warp']}>
            <span className={styles['remark-counter']}>{valueLen} / 1000</span>
          </div>
        </div>
        <div className={styles['kp-button-wrapper']}>
          <div className={styles['kp-cancel']} onClick={handleCancelRemark}>
            {t('取消')}
          </div>
          <button
            form-type="submit"
            className={styles['kp-confirm']}
            onClick={handleSubmitRemark}
          >
            {t('确认')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default RemarkBox
